export const getKeyboardEventKeyCode = (ev: KeyboardEvent) => {
    return ev.code || ev.keyCode; // IE11: fallback to keyCode
};
